

import React from 'react';
import { Container } from 'reactstrap';
import './footer.css';

const Footer = () => {
  return (
    <footer className='pb-4'>
        <Container className='text-center footer'>
            <p>
                &copy; 2022, Developed by Landry SAWA INGABIRE. All Rights reserved
            </p>
        </Container>
    </footer>
  )
}

export default Footer